'use client';

import { useState } from 'react';
import { useTranslations } from 'next-intl';
import styles from './Newsletter.module.css';

export default function Newsletter({ locale = 'en' }) {
  const t = useTranslations('newsletter');
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (email) {
      setSubmitted(true);
      setEmail('');
      setTimeout(() => setSubmitted(false), 3000);
    }
  };

  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <h2 className={styles.title}>{t('heading')} 🐾</h2>
        <p className={styles.subtitle}>
          {t('subtitle')}
        </p>

        <form className={styles.form} onSubmit={handleSubmit}>
          <input
            type="email"
            placeholder={t('emailPlaceholder')}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className={styles.input}
          />
          <button type="submit" className={styles.button}>
            {t('subscribe')}
          </button>
        </form>

        {submitted && (
          <p className={styles.success}>{t('successMessage')}</p>
        )}
      </div>
    </section>
  );
}
